import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NavigationModule } from '@features/navigation';

import {
  MainContentComponent,
  MainContentContainerComponent,
  PageNotFoundComponent,
  ErrorBaseComponent,
  InternalServerErrorComponent,
} from './components';
import { BadRequestComponent } from './components/error-pages/400/400.component';

@NgModule({
  imports: [
    CommonModule,
    NavigationModule,
    RouterModule,
    MainContentContainerComponent,
    MainContentComponent,
    ErrorBaseComponent,
    PageNotFoundComponent,
    InternalServerErrorComponent,
    BadRequestComponent,
  ],
})
export class MainContentModule {}
